// 活动管理 - 报名记录
import service from '@/utils/request'

// 报名记录
export function getActRanking(data) {
    return service({
        url: '/service/admin/getActRanking',
        method: 'post',
        params: data
    })
}

// 小程序二维码
export function getMiniAppQrcode(data) {
    return service({
        url: '/service/app/get_page_qrcode',
        method: 'post',
        params: data
    })
}

// 导出报名记录
export function Registration(data) {
    return service({
        url: '/service/admin/business_member_export',
        method: 'get',
        params: data,
        responseType: 'blob'
    })
}

// 报名审核
export function actEnrollAudit(data) {
    return service({
        url: '/service/admin/act_enroll_audit',
        method: 'post',
        params: data
    })
}

// 编辑成员协会
export function busMemberEdit(data) {
    return service({
        url: '/service/admin/bus_member_edit',
        method: 'post',
        params: data
    })
}